var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-details"},[_c('h5',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t("basic-details")))]),_c('FormGenerator',_vm._b({attrs:{"elements":_vm.elements,"handleUpdate":_vm.handleUpdate,"data":_vm.book,"inline":"","shouldCheckValidity":_vm.validate}},'FormGenerator',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }